import { ColorDto } from './ColorDto';

export class CashMovementReconciliationPreload {
  colors: Array<ColorDto>;
  sources: Array<string>;
  currencies: Array<string>;
}
